import { render, staticRenderFns } from "./PaypalCardSummary.vue?vue&type=template&id=b8dfe870&scoped=true&"
import script from "./PaypalCardSummary.vue?vue&type=script&lang=js&"
export * from "./PaypalCardSummary.vue?vue&type=script&lang=js&"
import style0 from "./PaypalCardSummary.vue?vue&type=style&index=0&id=b8dfe870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8dfe870",
  null
  
)

export default component.exports